/**
 * Latest Posts Block Frontend JavaScript
 *
 * @package Modern_Blocks
 */
import './frontend.css';
require('./frontend.css');

(function() {
	'use strict';

	// Initialize animations when DOM is ready
	document.addEventListener('DOMContentLoaded', function() {
		initLatestPostsAnimations();
	});

	/**
	 * Initialize animations for latest posts block
	 */
	function initLatestPostsAnimations() {
		const latestPostsBlocks = document.querySelectorAll('.latest-posts-container');
		
		latestPostsBlocks.forEach(block => {
			// Set up intersection observer for animations
			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						animateBlock(entry.target);
						observer.unobserve(entry.target);
					}
				});
			}, {
				threshold: 0.1,
				rootMargin: '0px 0px -50px 0px'
			});

			observer.observe(block);
		});
	}

	/**
	 * Animate block elements with staggered delays
	 */
	function animateBlock(block) {
		const animationType = block.dataset.animationType || 'fade-up';
		const baseDelay = parseFloat(block.dataset.animationDelay) || 0.2;
		
		// Animate company logo
		const logoSection = block.querySelector('.company-logo-section');
		if (logoSection) {
			animateElement(logoSection, animationType, baseDelay);
		}

		// Animate post tiles with staggered delays
		const postTiles = block.querySelectorAll('.post-tile');
		postTiles.forEach((tile, index) => {
			const delay = baseDelay + (index * 0.2);
			animateElement(tile, animationType, delay);
		});
	}

	/**
	 * Animate individual element
	 */
	function animateElement(element, animationType, delay) {
		if (!element) return;

		// Set initial state based on animation type
		setInitialAnimationState(element, animationType);
		
		// Apply animation after delay
		setTimeout(() => {
			element.classList.add('animate-in');
		}, delay * 1000);
	}

	/**
	 * Set initial animation state based on type
	 */
	function setInitialAnimationState(element, animationType) {
		// Remove any existing animation classes
		element.classList.remove('animate-in', 'animate-fade-up', 'animate-fade-in', 'animate-slide-left', 'animate-slide-right', 'animate-scale-up', 'animate-bounce-in');
		
		// Add the appropriate animation class
		element.classList.add(`animate-${animationType}`);
	}

	/**
	 * Handle post tile interactions
	 */
	function initPostTileInteractions() {
		const postTiles = document.querySelectorAll('.post-tile');
		
		postTiles.forEach(tile => {
			// Add hover effects
			tile.addEventListener('mouseenter', function() {
				this.style.transform = 'translateY(-8px)';
			});
			
			tile.addEventListener('mouseleave', function() {
				this.style.transform = 'translateY(0)';
			});

			// Add click tracking for analytics (if needed)
			tile.addEventListener('click', function(e) {
				const link = this.querySelector('a[href]');
				if (link && !e.target.closest('.read-more-button')) {
					// Track post tile click
					trackPostClick(link.href, this.querySelector('.post-tile-title')?.textContent || '');
				}
			});
		});
	}

	/**
	 * Track post clicks for analytics
	 */
	function trackPostClick(url, title) {
		// Add your analytics tracking code here
		if (typeof gtag !== 'undefined') {
			gtag('event', 'post_click', {
				'event_category': 'latest_posts',
				'event_label': title,
				'value': url
			});
		}
	}

	/**
	 * Handle responsive layout changes
	 */
	function handleResponsiveLayout() {
		const latestPostsBlocks = document.querySelectorAll('.latest-posts-container');
		
		latestPostsBlocks.forEach(block => {
			const postsGrid = block.querySelector('.posts-grid');
			if (!postsGrid) return;

			// Check if we need to adjust layout based on screen size
			const adjustLayout = () => {
				const isMobile = window.innerWidth < 768;
				const isTablet = window.innerWidth < 1024;
				
				if (isMobile) {
					postsGrid.classList.add('mobile-layout');
					postsGrid.classList.remove('tablet-layout', 'desktop-layout');
				} else if (isTablet) {
					postsGrid.classList.add('tablet-layout');
					postsGrid.classList.remove('mobile-layout', 'desktop-layout');
				} else {
					postsGrid.classList.add('desktop-layout');
					postsGrid.classList.remove('mobile-layout', 'tablet-layout');
				}
			};

			// Initial adjustment
			adjustLayout();

			// Listen for resize events
			window.addEventListener('resize', debounce(adjustLayout, 250));
		});
	}

	/**
	 * Debounce function for performance
	 */
	function debounce(func, wait) {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}

	/**
	 * Initialize lazy loading for images
	 */
	function initLazyLoading() {
		const images = document.querySelectorAll('.post-tile-image img');
		
		if ('IntersectionObserver' in window) {
			const imageObserver = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						const img = entry.target;
						if (img.dataset.src) {
							img.src = img.dataset.src;
							img.classList.remove('lazy');
							imageObserver.unobserve(img);
						}
					}
				});
			});

			images.forEach(img => {
				if (img.dataset.src) {
					img.classList.add('lazy');
					imageObserver.observe(img);
				}
			});
		}
	}

	/**
	 * Initialize all functionality
	 */
	function init() {
		initLatestPostsAnimations();
		initPostTileInteractions();
		handleResponsiveLayout();
		initLazyLoading();
	}

	// Initialize when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	// Re-initialize for dynamically loaded content
	if (typeof wp !== 'undefined' && wp.hooks) {
		wp.hooks.addAction('blocks/latest-posts/loaded', 'modern-blocks', init);
	}

})();
